import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../_common/application/ts/Glob';
import BooleanField from '../../../../_common/platform/tsx/BooleanField';
import NumberField from '../../../../_common/platform/tsx/NumberField';
import StringField from '../../../../_common/platform/tsx/StringField';
import AttrQueryFilterField from '../../../../_common/platform/tsx/filtering/AttrQueryFilterField';
import { QueryRootEntityField } from '../../../../_common/platform/tsx/QueryRootEntityField';
import { ReorderButton } from '../../../../_common/platform/tsx/ReorderButton';
import AttrQueryField, { IAttrQueryFieldOptions } from './AttrQueryField';
import SelectField from '../../../../_common/platform/tsx/SelectField';
import { DEFAULT_DATASOURCE_ID, DataloadEventTypes } from '../../../../pdc-platform/src/ts/stores/EntityModelsStore';
import { addIDToItems } from '../../../../_common/platform/ts/Utilities';
import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';
import { validators as ChartValidators } from '../../../../pdc-widget-chart/src/ts/validators';

import ParameterFieldBase, {
    IParameterFieldBaseOptions,
    IValidator
} from '../../../../_common/platform/ts/ParameterFieldBase';

import {
    IQueryFilter,
    IAttrQueryFilterFieldValue,
    IGlobalFilterControl
} from '../../../../_common/platform/tsx/filtering/Interfaces';

import { IAttrQuery, IAttrQueryMulti, IAttrQueryValue } from './Interfaces';
import { AXIS_LIST, getVariatedAxisList } from '../chartConstants';

class AttrQueryMultiFieldRow extends React.Component<
    {
        value?;
        values?: { [fieldName: string]: any };
        i?: number;
        fictiv?: boolean;
        empty?: boolean;
        axisList?;
        showInTooltip_Defaults?;
        dataDescriptor?: IAttrQueryValue[];
        dataSourceID?: number;

        nQueries?: number; //LL: for ReorderButton

        chartTypeMainFieldName?: string;
        chartCustomStylesFieldName_inTheme?: string;

        chartAxisArrayFieldName_inTheme?: string;

        onGetValidAxisMain2?;
        onGetAxisConversion?;
        onGetFullAxisArray?;
        onGetExtendedAxisArray?;
        onEvalAuxAxisNames?;
        get_colorMappingForNumericFromTheme_Func?;
        colorMappingForNumericFromTheme_both?;
        formatsDateTime?;
        formatsNumeric?;
        xIDs?;
        argumentAxisProhibited?;
        includeSeparateValueAxis?;
        ownChartType?: boolean;
        dsChanged?;
        validFilterObj?;
        chartTypesArray?: any[];
        secondaryValueAxisArray?: any[];
        secondaryValueAxis?;
        chartType?;
        chartTypeMain?;
        showTitle?: boolean;
        title?: string;
        showUsed?: boolean;
        used?;
        distinct?;
        limit?;
        queryRootEntity?: string;
        showUsedSingle?: boolean;
        defaultValueAxis?;
        isMultiDataSourceMode?: boolean;
        dataSourceIds?: any[];
        dataSourceNames?: string[];
        filter?: IQueryFilter[];
        globalFilterControl?: IGlobalFilterControl;
        tabID: number;
        extendedAxisDisplay_FieldName?: string;
        validators_AttrQueryField?: IValidator[];
        validators_AttrQueryFilterField?: IValidator[];
        theme?: IValuesCollection;
        glob: IGlob;

        onChange?(value, i): void;
        onRemove?(i): void;
        onAddRow?(obj): void;
        onAddRow_CopyArgument?(obj): void;
        onAddRow_ClonedPrevious?(): void;
        onChangeFilter?(value: IAttrQueryFilterFieldValue): void;
        onChangeTitle?(val): void;
        onChangeChartType?(value: string): void;
        onChangeUsed?(value: boolean): void;
        onChangeDistinct?(value: boolean): void;
        onChangeQueryRootEntity?(value: string): void;
        onChangeLimit?(value: number): void;
        onChangeSecondaryValueAxis?(value: string): void;
        onChangeDataSource?(value: string): void;
    },
    {}
> {
    constructor(props) {
        super(props);
    }

    isFictiv = () => {
        return this.props.fictiv === true;
    };

    normalize = (value) => {
        if (value.dataDescriptor == null) {
            return;
        }
    };

    handleValueChange = (value) => {
        this.normalize(value);

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    };

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    getRemoveButton = (value: IAttrQueryValue[]) => {
        if (this.isFictiv()) {
            return;
        }

        if (value == null) {
            return;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    };

    getDataDescriptor = (
        attrQueryValues: IAttrQueryValue[],
        chartTypeValue,
        dataSourceID: number,
        validEntities: string[]
    ) => {
        if (attrQueryValues == null) {
            return <span className="glyphicon glyphicon-cog"></span>;
        }

        let options: IAttrQueryFieldOptions = {
            chartTypeMainFieldName: this.props.chartTypeMainFieldName,
            onGetValidAxisMain2: this.props.onGetValidAxisMain2,
            onGetFullAxisArray: this.props.onGetFullAxisArray,
            onGetExtendedAxisArray: this.props.onGetExtendedAxisArray,
            AxisList: this.props.axisList,
            ShowInTooltip_Defaults: this.props.showInTooltip_Defaults,

            ChartAxisArrayFieldName_inTheme: this.props.chartAxisArrayFieldName_inTheme,

            onEvalAuxAxisNames: this.props.onEvalAuxAxisNames,

            chartCustomStylesFieldName_inTheme: this.props.chartCustomStylesFieldName_inTheme,

            Xids: this.props.xIDs,
            argumentAxisProhibited: this.props.argumentAxisProhibited,
            includeSeparateValueAxis: this.props.includeSeparateValueAxis,

            dataSourceID: dataSourceID,
            chartTypeOwn: null,
            validEntities: validEntities
        };

        if (this.props.ownChartType === true) {
            options.chartTypeOwn = chartTypeValue;
        }

        options.dataSourceID = dataSourceID;

        const errors: string[] = [];
        const error = ChartValidators.attrquery_multi_charts.validateAttrQueryValues(attrQueryValues);

        if (error != null) {
            errors.push(...error);
        }

        let errorsHTML: React.JSX.Element;

        if (errors.length > 0) {
            errorsHTML = <span className="validation-error">{errors.join(', ')}</span>;
        }

        let label: React.JSX.Element;

        if (errorsHTML != null) {
            label = <label>{errorsHTML}</label>;
        }

        // See WI 101342. ID is needed to make visual reoredring work.
        addIDToItems(attrQueryValues);

        //LL: this.props.values are values of Chart (main.ts): ChartTypeMain, etc
        return (
            <div>
                {label}
                <AttrQueryField
                    value={attrQueryValues}
                    values={this.props.values}
                    options={options}
                    tabID={this.props.tabID}
                    themeObj={this.props.theme}
                    glob={this.props.glob}
                    onChange={this.handleValueChange}
                />
            </div>
        );
    };

    getFilter = (
        dataSourceID: number,
        filters: IQueryFilter[],
        globalFilterControl: IGlobalFilterControl,
        validEntities: string[]
    ) => {
        let valid = true;
        let errors;

        let filterOptions: any = {};
        filterOptions.dataSourceID = dataSourceID;
        if (this.props.dsChanged != null) {
            filterOptions.dsChanged = this.props.dsChanged;
        }

        let validFilterObj = this.props.validFilterObj || {};
        errors = validFilterObj.errors;
        if (validFilterObj.valid != null) {
            valid = validFilterObj.valid;
        }

        let errorsHTML;
        if (valid !== true) {
            errorsHTML = <span className="validation-error">{errors.join(', ')}</span>;
        }

        let label;
        if (errorsHTML != null) {
            label = <label>{errorsHTML}</label>;
        }

        return (
            <div>
                {label}
                <AttrQueryFilterField
                    value={{
                        filters: filters,
                        globalFilterControl: globalFilterControl
                    }}
                    dataSourceID={dataSourceID}
                    options={filterOptions}
                    validEntities={validEntities}
                    theme={this.props.theme}
                    tabID={this.props.tabID}
                    onChange={this.props.onChangeFilter}
                    glob={this.props.glob}
                />
            </div>
        );
    };

    processAddFresh = (e) => {
        let obj = [];
        if (typeof this.props.onAddRow === 'function') {
            this.props.onAddRow(obj);
        }
    };

    processAddFresh_CopyArgument = (e) => {
        let obj = [];
        if (typeof this.props.onAddRow_CopyArgument === 'function') {
            this.props.onAddRow_CopyArgument(obj);
        }
    };

    processAddFresh_ClonedPrevious = (e) => {
        if (typeof this.props.onAddRow_ClonedPrevious === 'function') {
            this.props.onAddRow_ClonedPrevious();
        }
    };

    getAddFresh = () => {
        let displayVal = (
            <button type="button" className="btn btn-default btn-sm" onClick={this.processAddFresh}>
                {'Add Data Query'}
            </button>
        );
        //LL: Leo asks to drop it
        let displayVal_CopyArgument = null;
        let displayVal_ClonedPrevious = (
            <button type="button" className="btn btn-default btn-sm" onClick={this.processAddFresh_ClonedPrevious}>
                {'Clone Previous Data Query'}
            </button>
        );

        return (
            <div className="entity-select">
                <div className="buttons-content">
                    <span className="value">{displayVal}</span>
                    <span className="value">{displayVal_CopyArgument}</span>
                    <span className="value">{displayVal_ClonedPrevious}</span>
                </div>
            </div>
        );
    };

    processTitleChange = (val) => {
        if (this.props.onChangeTitle != null) {
            this.props.onChangeTitle(val);
        }
    };

    getBlock = () => {
        let chartTypeValue;
        let chartTypeElem;
        if (this.props.ownChartType === true) {
            let ChartTypesArray = [];
            if (this.props.chartTypesArray != null) {
                ChartTypesArray = this.props.chartTypesArray;
            }

            let chartTypeOptions = {
                values: ChartTypesArray.slice(0),
                display: ChartTypesArray.slice(0)
            };

            if (this.props.chartType != null) {
                chartTypeValue = this.props.chartType;
            }
            if (chartTypeValue == null) {
                if (this.props.chartTypeMain != null) {
                    chartTypeValue = this.props.chartTypeMain;
                }
            }
            if (chartTypeValue == null) {
                chartTypeValue = 'bar';
            }

            chartTypeElem = (
                <div className="col-sm-2">
                    <strong>{'Chart Type'}</strong>
                    <SelectField
                        value={chartTypeValue}
                        options={chartTypeOptions}
                        onChange={this.props.onChangeChartType}
                    />
                </div>
            );
        }

        let secondaryValueAxisValue;
        let secondaryValueAxisListElem;

        let canValueAxisListElem = chartTypeValue !== 'pie' && chartTypeValue !== 'doughnut';
        if (canValueAxisListElem) {
            if (this.props.secondaryValueAxisArray == null || this.props.secondaryValueAxisArray.length === 0) {
                canValueAxisListElem = false;
            }
        }

        if (canValueAxisListElem && this.props.includeSeparateValueAxis === true) {
            let defaultValueAxis = this.props.defaultValueAxis;
            if (defaultValueAxis == null) {
                defaultValueAxis = 'Y'; // 'none';
            }

            let secondaryValueAxisArray = [defaultValueAxis];
            if (this.props.secondaryValueAxisArray != null) {
                secondaryValueAxisArray = secondaryValueAxisArray.concat(this.props.secondaryValueAxisArray);
            }

            let secondaryValueAxisOptions = {
                values: secondaryValueAxisArray.slice(0),
                display: secondaryValueAxisArray.slice(0)
            };

            if (this.props.secondaryValueAxis != null) {
                secondaryValueAxisValue = this.props.secondaryValueAxis;
            }
            if (secondaryValueAxisValue == null) {
                secondaryValueAxisValue = defaultValueAxis;
            }

            //  Use Secondary Value Axis
            secondaryValueAxisListElem = (
                <div className="col-sm-1">
                    <strong>{'Value Axis'}</strong>
                    <SelectField
                        value={secondaryValueAxisValue}
                        options={secondaryValueAxisOptions}
                        onChange={this.props.onChangeSecondaryValueAxis}
                    />
                </div>
            );
        }

        let titleElem;

        if (this.props.showTitle === true) {
            let titleValue: string;

            if (this.props.title != null) {
                titleValue = this.props.title;
            }

            if (titleValue == null) {
                titleValue = '';
            }

            const placeholder = getDefaultTitleForAttrQuery(this.props.i);

            titleElem = (
                <div className="col-sm-3">
                    <strong>{'Title'}</strong>

                    <StringField onChange={this.processTitleChange} value={titleValue} placeholder={placeholder} />
                </div>
            );
        }

        let usedElem;

        if (this.props.showUsed === true) {
            let usedValue;

            if (this.props.used != null) {
                usedValue = this.props.used;
            }
            if (usedValue == null) {
                usedValue = true;
            }

            let styleU: any = {};
            if (this.props.showUsedSingle === true) {
                styleU.border = 'red solid 1px';
            }

            usedElem = (
                <div className="col-sm-1" style={styleU}>
                    <strong>{'Enabled'}</strong>
                    <BooleanField title={''} value={usedValue} onChange={this.props.onChangeUsed} />
                </div>
            );
        }

        let dataSourceID: number;
        let dataSourceIdActual;
        let dataSourceElem;

        if (this.props.isMultiDataSourceMode === true) {
            let dataSourceOptions = {
                values: this.props.dataSourceIds.slice(0),
                display: this.props.dataSourceNames.slice(0)
            };

            if (this.props.dataSourceID != null) {
                dataSourceID = this.props.dataSourceID;
            }

            if (dataSourceID != null) {
                let fnd = false;
                for (let ids = 0; ids < this.props.dataSourceIds.length; ids++) {
                    if (this.props.dataSourceIds[ids] === dataSourceID) {
                        fnd = true;
                        break;
                    }
                }

                if (!fnd) {
                    dataSourceID = DEFAULT_DATASOURCE_ID;
                }
            }

            dataSourceIdActual = dataSourceID;
            if (dataSourceID == null) {
                dataSourceID = DEFAULT_DATASOURCE_ID;
            }

            dataSourceElem = (
                <div className="col-sm-3">
                    <strong>{'Data Source'}</strong>
                    <SelectField
                        value={dataSourceID.toString()}
                        options={dataSourceOptions}
                        onChange={this.props.onChangeDataSource}
                    />
                </div>
            );
        } else {
            dataSourceIdActual = DEFAULT_DATASOURCE_ID;
        }

        let queryRootEntityValue = 'default';

        if (this.props.queryRootEntity != null) {
            queryRootEntityValue = this.props.queryRootEntity;
        }

        let queryRootEntityElem = (
            <div className="col-sm-2 cell-queryRootEntity">
                <QueryRootEntityField
                    value={queryRootEntityValue}
                    dataSourceID={dataSourceID}
                    glob={this.props.glob}
                    onChange={this.props.onChangeQueryRootEntity}
                />
            </div>
        );

        let distinctElem;
        let distinctValue = false;

        if (this.props.distinct != null) {
            distinctValue = this.props.distinct;
        }

        distinctElem = (
            <div className="col-sm-1">
                <strong>{'Distinct'}</strong>
                <BooleanField title={''} value={distinctValue} onChange={this.props.onChangeDistinct} />
            </div>
        );

        let limitElem;
        let limitValue = 0;

        if (this.props.limit != null) {
            limitValue = this.props.limit;
        }

        limitElem = (
            <div className="col-sm-1">
                <strong>{'Data Limit'}</strong>
                <NumberField
                    value={limitValue}
                    onChange={this.props.onChangeLimit}
                    allowNull={false}
                    applyOnEnter={true}
                    integer={true}
                    notNegative={true}
                    max={2147483647}
                />
            </div>
        );

        //LL: add Distinct and Data Limit into each Query, so row0 is not enough
        let row0;

        //LL: class "row" has marginLeft = -5px, marginRight = -5px  It is flex container
        let styleRow = {
            marginTop: '3px',
            marginLeft: 0,
            marginRight: 0
        };

        row0 = (
            <tr>
                <td className="cell-remove" style={{ verticalAlign: 'top' }}>
                    <ReorderButton nItems={this.props.nQueries} />
                </td>
                <td colSpan={1} className="row0-container container">
                    <div className="row" style={styleRow}>
                        {dataSourceElem}
                        {queryRootEntityElem}
                        {distinctElem}
                        {limitElem}
                        {chartTypeElem}
                        {secondaryValueAxisListElem}
                        {titleElem}
                        {usedElem}
                    </div>
                </td>
            </tr>
        );

        let dataDescriptor = this.props.dataDescriptor || [];
        let filter = this.props.filter || ({} as IQueryFilter[]);

        let style1 = {
            marginBottom: 14,
            width: '100%'
        }; // class "table" has margin-bottom:20px

        let styleFilter = {
            marginTop: 12
        };

        const validEntities = this.props.glob.EntityModelsStore.getValidEntitiesForMultipeRootFunctionality(
            dataDescriptor,
            filter
        );

        return (
            <table className="table" style={style1}>
                <tbody>
                    {row0}

                    <tr>
                        <td className="cell-remove">{this.getRemoveButton(dataDescriptor)}</td>
                        <td colSpan={1} className="dataDescriptor-container">
                            {this.getDataDescriptor(dataDescriptor, chartTypeValue, dataSourceIdActual, validEntities)}
                        </td>
                    </tr>

                    <tr>
                        <td className="cell-remove"></td>
                        <td colSpan={1} className="filter-container">
                            <div style={styleFilter}>
                                {this.getFilter(
                                    dataSourceIdActual,
                                    filter,
                                    this.props.globalFilterControl,
                                    validEntities
                                )}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    render() {
        if (this.isFictiv()) {
            let a = this.getAddFresh();
            return (
                <tr className="query-row">
                    <td className="cell-remove"></td>
                    <td colSpan={1}>{a}</td>
                </tr>
            );
        }

        let block = this.getBlock();
        return (
            <tr className="query-row">
                <td colSpan={2}>{block}</td>
            </tr>
        );
    }
}

export interface IAttrQueryMultiFieldValue {
    reorder?: boolean;
    attrQueries?: IAttrQuery[];
    enabled?: boolean;
    globalFilterControl?: IGlobalFilterControl;
}

interface IAttrQueryMultiFieldOptions extends IParameterFieldBaseOptions {
    ownChartType?;
    includeSeparateValueAxis?;

    chartTypeMainFieldName?: string;
    chartCustomStylesFieldName_inTheme?: string;
    extendedAxisDisplay_FieldName?: string;
    argumentAxis_AxisType_FieldName?: string;

    ChartAxisArrayFieldName_inTheme?: string;

    distinctName?: string;
    limitName?: string;

    ShowInTooltip_Defaults?;
    get_colorMappingForNumericFromTheme_Func?;
    formatsDateTime?;
    formatsNumeric?;
    validators_AttrQueryField?: IValidator[];
    validators_AttrQueryFilterField?: IValidator[];
    colorMappingForNumericFromTheme_both?;
    argumentAxisProhibited?;

    onGetFullChartTypesArray?;
    onGetValidAxisMain2?;
    onGetFullAxisArray?;
    onGetExtendedAxisArray?;
    onEvalAuxAxisNames?;
    onChangeChartTypeAndAxisInAttrQuery?;
    onGetAxisConversion?;

    onGetXids?();
}

interface IAttrQueryMultiFieldComponentState {
    chartTypeSaved;
    secondaryValueAxisSaved;
    titleSaved;
    usedSaved;
    distinctSaved;
    limitSaved;
}

class AttrQueryMultiFieldComponent extends React.Component<
    {
        value: IAttrQueryMultiFieldValue;
        values;

        options: IAttrQueryMultiFieldOptions;
        themeObj?: IValuesCollection;

        onGetAxisConversion?;
        onGetValidAxisMain2?;
        colorMappingForNumericFromTheme_both?;
        Xids?;
        border?: boolean;
        glob: IGlob;

        onChange(value: IAttrQueryMultiFieldValue): void;
    },
    IAttrQueryMultiFieldComponentState
> {
    private references: {
        tableBody?: HTMLTableSectionElement;
    } = {};

    private attrQueryValidatorObj = null;
    private attrQueryFilterValidatorObj = null;
    private useOwnChartType: boolean = false;
    private includeSeparateValueAxis: boolean = false;
    private defaultValueAxis: string = 'Y'; // 'none',
    private dataSourceChangedIndex: number = -1;

    constructor(props) {
        super(props);

        if (this.props.value.reorder === true) {
            delete this.props.value.reorder;
        }

        if (this.props.options.ownChartType != null) {
            this.useOwnChartType = this.props.options.ownChartType;
        }

        if (this.props.options.includeSeparateValueAxis != null) {
            this.includeSeparateValueAxis = this.props.options.includeSeparateValueAxis;
        }

        const options = {
            chartTypeMainFieldName: this.props.options.chartTypeMainFieldName,
            onGetValidAxisMain2: this.props.options.onGetValidAxisMain2,
            onGetAxisConversion: this.props.onGetAxisConversion,
            onGetFullAxisArray: this.props.options.onGetFullAxisArray,
            onGetExtendedAxisArray: this.props.options.onGetExtendedAxisArray,
            AxisList: AXIS_LIST,
            ShowInTooltip_Defaults: this.props.options.ShowInTooltip_Defaults,

            ChartAxisArrayFieldName_inTheme: this.props.options.ChartAxisArrayFieldName_inTheme,

            onEvalAuxAxisNames: this.props.options.onEvalAuxAxisNames,

            chartCustomStylesFieldName_inTheme: this.props.options.chartCustomStylesFieldName_inTheme,
            get_colorMappingForNumericFromTheme_Func: this.props.options.get_colorMappingForNumericFromTheme_Func,
            colorMappingForNumericFromTheme_both: this.props.colorMappingForNumericFromTheme_both,
            formatsDateTime: this.props.options.formatsDateTime,
            formatsNumeric: this.props.options.formatsNumeric,
            Xids: this.props.Xids
        };

        this.attrQueryValidatorObj = new ParameterFieldBase<IAttrQueryMultiFieldOptions>(
            this.props.glob,
            '',
            this.props.options.validators_AttrQueryField,
            [],
            options
        );

        let validatorsFilter = this.props.options.validators_AttrQueryFilterField;
        this.attrQueryFilterValidatorObj = new ParameterFieldBase<IAttrQueryMultiFieldOptions>(
            this.props.glob,
            '',
            validatorsFilter,
            [],
            {}
        );

        this.validateAll(this.props.value.attrQueries);

        this.state = {
            chartTypeSaved: null,
            secondaryValueAxisSaved: null,
            titleSaved: null,
            usedSaved: null,
            distinctSaved: null,
            limitSaved: null
            //dataSourceChangedIndex: -1  //LL for Filter
        };
    }

    private startIndex: number = 0;

    reorderStart = (e, ui) => {
        this.startIndex = $(ui.item).index();

        //LL: TRY
        //  https://stackoverflow.com/questions/12078289/controlling-placeholder-height-with-jquery-ui-sortable
        //  http://jsfiddle.net/jCNcv/2/
        //ui.placeholder.height(50);  // TRY

        //  jquery ui sortable placeholder cannot change background colour
        //  https://stackoverflow.com/questions/11523030/jquery-ui-sortable-placeholder-cannot-change-background-colour
        //  http://jsfiddle.net/EUVrK/3/
        //     According to the jQuery UI Sortable Documentation you can provide a css class for the placeholder.
        //     You should be able to specify the background in this class.
        //
        //     @import '../../../_common/application/sass/attrquery-multi-field'
        //
        //LL:  see definition of .sortable in componentDidMount - placeholder  and sass

        //  TRY:  ok
        ui.placeholder.css('visibility', 'visible');
        ui.placeholder.css('background-color', '#fffae3'); // yellow
    };

    reorderStop = (e, ui) => {
        if (this.startIndex == null) {
            return;
        }

        let startIndex = this.startIndex;
        let stopIndex = $(ui.item).index();

        delete this.startIndex;

        //LL: see: https://gist.github.com/avakhov/7b9d2b1a354e59dbfa63
        //   Вызываем cancel, чтобы элементы местами поменял React.js
        //   $(me.getDOMNode()).sortable("cancel");
        $(this.references.tableBody).sortable('cancel');
        this.processReorder(startIndex, stopIndex);
    };

    validateAttrQuery = (value) => {
        let valid = true;
        let errors;

        if (value != null) {
            errors = this.attrQueryValidatorObj.errors;
            valid = errors == null || errors.length === 0;
        }

        return { valid: valid, errors: errors };
    };

    validateAttrQueryFilter = (value) => {
        let valid = true;
        let errors;

        if (value != null) {
            errors = this.attrQueryFilterValidatorObj.errors;
            valid = errors == null || errors.length === 0;
        }

        return { valid: valid, errors: errors };
    };

    validateAll = (attrQueries: IAttrQuery[]) => {
        _.each(attrQueries, (attrQuery) => {
            attrQuery.valid = this.validateAttrQuery(attrQuery.dataDescriptor);
            attrQuery.validFilter = this.validateAttrQueryFilter(attrQuery.filter);
        });
    };

    componentDidMount() {
        //LL: immediately after initial render
        let self = this;

        this.props.glob.EntityModelsActions.loadModels();
        this.props.glob.EntityModelsStore.addOnDataLoadListener(this.handleOnEntityModelsChange);

        $(this.references.tableBody).sortable({
            axis: 'y',
            forcePlaceholderSize: true,
            helper: function (e, src: any) {
                //LL:
                //  A function that will return a DOMElement to use while dragging.
                //  The function receives the event and the element being sorted.
                //var dragElements = $('<tr style="height:auto"><td colspan="5"><table style="width:98%"><tbody></tbody></table></td></tr>');
                //getChildren(dragElements, src);

                //let dragElements: any = $('<p style="height:auto">BBB</p>');
                //return dragElements;

                let rowIndex = src[0].rowIndex;
                let title;

                if (self.props.value.attrQueries != null && self.props.value.attrQueries.length > 0) {
                    let aq = self.props.value.attrQueries[rowIndex];

                    if (aq != null && aq.parameters != null) {
                        title = aq.parameters.title;
                    }
                }

                if (title == null) {
                    title = getDefaultTitleForAttrQuery(rowIndex);
                }

                let dragElem: any = $(
                    '<div height="1.5em" style="background-color:#aaaaaa; height:1.5em; line-height:1.2em;">' +
                        title +
                        '</div>'
                );

                return dragElem;
            },

            items: 'tr.query-row:not(.empty)',

            opacity: 0.8,
            handle: '.dx-icon-dragvertical',
            cursor: 'grabbing',
            start: this.reorderStart,
            stop: this.reorderStop
        });

        //LL: create 1st empty Block, if there are none (will be when Chart is created)
        if (this.props.value.attrQueries != null && this.props.value.attrQueries.length === 0) {
            let obj = [];
            this.addRow(obj);
        }
    }

    componentWillUnmount() {
        this.props.glob.EntityModelsStore.removeOnDataLoadListener(this.handleOnEntityModelsChange);

        $(this.references.tableBody).sortable('destroy');
    }

    //EVG It allows to control on which event the component should be refreshed.
    handleOnEntityModelsChange = (eventType: DataloadEventTypes) => {
        if (eventType === DataloadEventTypes.MODEL) {
            this.setState(this.state);
        }
    };

    componentWillUpdate(nextProps, nextState) {
        //LL: when externally changed, ex chartType is changed - so validate:  nextProps.value
        //LL: componentWillUpdate is not called, if shouldComponentUpdate returns false

        if (nextProps.value.attrQueries == null) {
            alert(
                'Chart: Wrong Chart definition - in AttrQueryMultiField.componentWillUpdate. \nPlease delete this Chart'
            );
        }

        let attrQueries = nextProps.value.attrQueries.slice(0);
        let changedErr = false;

        for (let j = 0; j < attrQueries.length; j++) {
            if (attrQueries[j].valids != null) {
                delete attrQueries[j].valids;
                changedErr = true;
            }
        }

        //LL: if this.includeSeparateValueAxis, correct ValueAxis by SecondaryValueAxis
        let changedValueAxis = false;

        if (this.includeSeparateValueAxis === true) {
            let secondaryValueAxisArray = [];
            let chartAxisArrayField = this._getChartAxisArrayField();

            if (chartAxisArrayField != null) {
                $.each(chartAxisArrayField, (key: any, obj) => {
                    //LL: these keys are outdated functionality, not used anywhere. Was used when in Params, not in Themes
                    if (key !== 'isSet' && key !== 'removeAxis') {
                        secondaryValueAxisArray.push(key);
                    }
                });
            }

            for (let j = 0; j < attrQueries.length; j++) {
                let secondaryValueAxis = attrQueries[j].parameters.secondaryValueAxis;

                if (secondaryValueAxis == null || secondaryValueAxis === this.defaultValueAxis) {
                    continue;
                }

                let fnd = false;
                for (let k = 0; k < secondaryValueAxisArray.length; k++) {
                    if (secondaryValueAxisArray[k] === secondaryValueAxis) {
                        fnd = true;
                        break;
                    }
                }
                if (!fnd) {
                    attrQueries[j].parameters.secondaryValueAxis = null;
                    changedValueAxis = true;
                }
            }
        }

        //LL: valid ChartType: XY or Pie   Before Validation
        let changedChartType = false;
        if (this.useOwnChartType === true) {
            let chartTypeMain = this._getChartTypeMain_byProps(nextProps);
            let chartTypesArray = [];

            if (typeof this.props.options.onGetFullChartTypesArray === 'function') {
                chartTypesArray = this.props.options.onGetFullChartTypesArray(chartTypeMain);
            }

            for (let j = 0; j < attrQueries.length; j++) {
                //LL:  if only one Block, full ChartTypes array (XY + Pie).  Otherwise depends on chartTypeMain (actually on 1st Block)
                //  So, don't verify for j = 0:

                let chartType = attrQueries[j].parameters.chartType;

                if (j === 0) {
                    if (
                        this.props.value.attrQueries != null &&
                        this.props.value.attrQueries[j].parameters != null &&
                        chartType === this.props.value.attrQueries[j].parameters.chartType
                    ) {
                        continue;
                    }
                }

                if (chartType != null) {
                    let fnd = false;

                    if (j !== 0) {
                        for (let k = 0; k < chartTypesArray.length; k++) {
                            if (chartTypesArray[k] === chartType) {
                                fnd = true;
                                break;
                            }
                        }
                    }

                    if (!fnd) {
                        if (j !== 0) {
                            chartType = chartTypeMain;
                        }

                        attrQueries[j].parameters.chartType = chartType;

                        let obj = attrQueries[j].dataDescriptor;

                        if (typeof this.props.options.onChangeChartTypeAndAxisInAttrQuery === 'function') {
                            this.props.options.onChangeChartTypeAndAxisInAttrQuery(
                                obj,
                                chartType,
                                this._getChartAxisArrayField(),
                                this._getExtendedAxisDisplay()
                            );
                        }

                        changedChartType = true;
                    }
                }
            }
        }

        this.validateAll(nextProps.value.attrQueries);

        //LL: problem:
        //   See in Chart's main.ts in changeAxisInAttrQueryMulti:
        //   ChartType is changed, internal AttrQuerys become invalid, but validation of the whole AttrQueryMulti goes before !!!
        //   So, we need to indicate that AttrQueryMulti must refresh

        //LL: invalid is set in Chart's main.ts in changeAxisInAttrQueryMulti
        if (changedErr || changedChartType || changedValueAxis || nextProps.value.invalid === true) {
            nextProps.value.invalid = false;

            //this.handleValueChange(nextProps.value);  //LL: wrong ?  works !

            //LL: better make copy:
            let value = _.clone(nextProps.value);
            value.attrQueries = nextProps.value.attrQueries.slice(0);
            value.enabled = true;
            this.handleValueChange(value);

            //LL: maybe use setState(...)  ???
        }
    }

    componentDidUpdate(prevProps, prevState) {
        //LL: yes, attrQueries are changed, but DOM not
        this.dataSourceChangedIndex = -1;
    }

    processReorder = (start, stop) => {
        if (start === stop) {
            return;
        }

        let value = _.clone(this.props.value);

        let movingItem = value.attrQueries.splice(start, 1);
        value.attrQueries.splice(stop, 0, movingItem[0]);
        //value.reorder = true;

        this.handleValueChange(value);
    };

    normalize = (value) => {
        if (value.attrQueries != null) {
            //LL: another decision: set "showUsed" param in such case
            ////LL: used=false for single can occur when there were 2, "used" set to false, and then the secong deleted
            //if (value.attrQueries.length === 1) {
            //    let used = value.attrQueries[0].parameters.used;
            //    if (used === false) {
            //        value.attrQueries[0].parameters.used = true;
            //    }
            //}
        }
    };

    handleValueChange = (value) => {
        this.normalize(value);

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    _getChartTypeMain = () => {
        //LL:  ChartTypeMain excluded, use ChartType of the 1st Block
        if (
            this.props.value != null &&
            this.props.value.attrQueries != null &&
            this.props.value.attrQueries.length > 0
        ) {
            let ct = this.props.value.attrQueries[0].parameters.chartType;
            if (ct != null && ct !== '') {
                return ct;
            }
        }

        let chartTypeMainFieldName = 'chartTypeMain';
        if (this.props.options != null && typeof this.props.options.chartTypeMainFieldName === 'string') {
            chartTypeMainFieldName = this.props.options.chartTypeMainFieldName;
        }

        let result = '';
        if (this.props.values != null) {
            if (this.props.values[chartTypeMainFieldName] != null) {
                result = this.props.values[chartTypeMainFieldName];
            }
        } else {
            alert('LL: AttrQueryMultiField _getChartTypeMain: this.props.values is null. Wrong platform version');
        }

        return result;
    };

    _getChartTypeMain_byProps = (Props) => {
        //LL:  ChartTypeMain excluded, use ChartType of the 1st Block
        if (Props.value != null && Props.value.attrQueries != null && Props.value.attrQueries.length > 0) {
            let ct = Props.value.attrQueries[0].parameters.chartType;
            if (ct != null && ct !== '') {
                return ct;
            }
        }

        let chartTypeMainFieldName = 'chartTypeMain';
        if (Props.options != null && typeof Props.options.chartTypeMainFieldName === 'string') {
            chartTypeMainFieldName = Props.options.chartTypeMainFieldName;
        }

        let result = '';

        if (Props.values != null) {
            if (Props.values[chartTypeMainFieldName] != null) {
                result = Props.values[chartTypeMainFieldName];
            }
        } else {
            alert('LL: AttrQueryMultiField _getChartTypeMain_byProps: Props.values is null. Wrong platform version');
        }

        return result;
    };

    _getDistinct = () => {
        let distinctName = 'distinct';
        if (this.props.options != null && typeof this.props.options.distinctName === 'string') {
            distinctName = this.props.options.distinctName;
        }

        let result = [];

        if (this.props.values != null) {
            if (this.props.values[distinctName] != null) {
                result = this.props.values[distinctName];
            }
        } else {
            alert('LL: AttrQueryMultiField _getDistinct: this.props.values is null. Wrong platform version');
        }

        return result;
    };

    _getLimit = () => {
        let limitName = 'limit';
        if (this.props.options != null && typeof this.props.options.limitName === 'string') {
            limitName = this.props.options.limitName;
        }

        let result = [];

        if (this.props.values != null) {
            if (this.props.values[limitName] != null) {
                result = this.props.values[limitName];
            }
        } else {
            alert('LL: AttrQueryMultiField _getLimit: this.props.values is null. Wrong platform version');
        }

        return result;
    };

    _getExtendedAxisDisplay = () => {
        let extendedAxisDisplay_FieldName = 'extendedAxisDisplay';
        if (this.props.options != null && typeof this.props.options.extendedAxisDisplay_FieldName === 'string') {
            extendedAxisDisplay_FieldName = this.props.options.extendedAxisDisplay_FieldName;
        }

        let result = false;

        if (this.props.values != null) {
            if (this.props.values[extendedAxisDisplay_FieldName] != null) {
                result = this.props.values[extendedAxisDisplay_FieldName];
            }
        } else {
            alert('LL: AttrQueryMultiField _getExtendedAxisDisplay: this.props.values is null. Wrong platform version');
        }

        return result;
    };

    _getChartAxisArrayField = () => {
        let result = [];
        let theme = this.getTheme();

        if (theme != null) {
            if (this.props.options != null && this.props.options.ChartAxisArrayFieldName_inTheme != null) {
                result = theme[this.props.options.ChartAxisArrayFieldName_inTheme];
            }
        }

        return result;
    };

    _get_argumentAxis_AxisType = () => {
        let argumentAxis_AxisType_FieldName = 'argumentAxis_AxisType';

        if (this.props.options != null && typeof this.props.options.argumentAxis_AxisType_FieldName === 'string') {
            argumentAxis_AxisType_FieldName = this.props.options.argumentAxis_AxisType_FieldName;
        }

        let argumentAxis_AxisType = 'default';

        if (this.props.values != null) {
            if (this.props.values[argumentAxis_AxisType_FieldName] != null) {
                argumentAxis_AxisType = this.props.values[argumentAxis_AxisType_FieldName];
            }
        } else {
            alert('LL: _get_argumentAxis_AxisType: this.props.values is null. Wrong platform version');
        }

        return argumentAxis_AxisType;
    };

    addRow_CopyArgument = (obj) => {
        //LL:  obj = []
        let v = this.props.value;
        if (v.attrQueries.length > 0) {
            let aq = v.attrQueries[v.attrQueries.length - 1];
            let dd = aq.dataDescriptor; //  arr
            if (dd != null) {
                let x1 = _.find(dd, function (item) {
                    return item.axis === 'X1';
                });
                if (x1 != null) {
                    x1 = $.extend(true, {}, x1);
                    //LL:  obj = []
                    obj.push(x1);
                }
            }
        }
        this.addRow(obj);
    };

    addRow_ClonedPrevious = () => {
        let value = _.clone(this.props.value);
        if (value.attrQueries.length > 0) {
            let aq = value.attrQueries[value.attrQueries.length - 1];

            aq = $.extend(true, {}, aq);
            let t = aq.parameters.title;
            if (t != null && t !== '') {
                aq.parameters.title += '_';
            }

            value.attrQueries.push(aq);
            value.enabled = true;
            this.handleValueChange(value);
        }
    };

    addRow = (obj) => {
        let value = _.clone(this.props.value);
        let val = this.validateAttrQuery(obj);
        let filter = [];
        let valFilter = this.validateAttrQueryFilter(filter);
        let isFirst = value.attrQueries.length === 0;
        let param: any = {};

        if (this.useOwnChartType === true) {
            //LL: ChartType may be changed before obj (DataDef) is create.
            //   We can save it in State in this case (no obj is created).  And here take it from State
            //LL: also see changeChartType(i)

            let chartTypeForEmpty;

            if (isFirst) {
                chartTypeForEmpty = this._getChartTypeMain();
            } else {
                // use previous ChartType
                chartTypeForEmpty = value.attrQueries[value.attrQueries.length - 1].parameters.chartType;
            }

            //EVG I have made it correct, but it has no used, because secondaryValueAxisSaved is never set. It seems obsolete.
            if (this.state.chartTypeSaved != null) {
                chartTypeForEmpty = this.state.chartTypeSaved;

                this.setState({
                    chartTypeSaved: null
                });
            }

            param.chartType = chartTypeForEmpty;
        }

        if (this.includeSeparateValueAxis === true) {
            let secondaryValueAxisForEmpty;

            //EVG I have made it correct, but it has no used, because secondaryValueAxisSaved is never set. It seems obsolete.
            if (this.state.secondaryValueAxisSaved != null) {
                secondaryValueAxisForEmpty = this.state.secondaryValueAxisSaved;

                this.setState({
                    secondaryValueAxisSaved: null
                });
            }

            param.secondaryValueAxis = secondaryValueAxisForEmpty;
        }

        // - title:
        let titleForEmpty;

        //EVG I have made it correct, but it has no used, because titleSaved is never set. It seems obsolete.
        if (this.state.titleSaved != null) {
            titleForEmpty = this.state.titleSaved;

            this.setState({
                titleSaved: null
            });
        }

        param.title = titleForEmpty;

        // - used:
        let usedForEmpty;

        //EVG I have made it correct, but it has no used, because usedSaved is never set. It seems obsolete.
        if (this.state.usedSaved != null) {
            usedForEmpty = this.state.usedSaved;

            this.setState({
                usedSaved: null
            });
        }

        param.used = usedForEmpty;

        // - distinctSaved
        let distinctForEmpty;

        //EVG I have made it correct, but it has no used, because distinctSaved is never set. It seems obsolete.
        if (this.state.distinctSaved != null) {
            distinctForEmpty = this.state.distinctSaved;

            this.setState({
                distinctSaved: null
            });
        }

        param.distinct = distinctForEmpty;

        // - limitSaved
        let limitForEmpty;

        //EVG I have made it correct, but it has no used, because limitSaved is never set. It seems obsolete.
        if (this.state.limitSaved != null) {
            limitForEmpty = this.state.limitSaved;

            this.setState({
                limitSaved: null
            });
        }

        param.limit = limitForEmpty;

        let dataSourceID_saved = this.props.glob.EntityModelsStore.getStoredDataSourceID();
        let dataSourceID = dataSourceID_saved;
        if (!isFirst && value.attrQueries[value.attrQueries.length - 1].dataSourceID != null) {
            dataSourceID = value.attrQueries[value.attrQueries.length - 1].dataSourceID;
        }

        let newQuery = {
            dataDescriptor: obj,
            filter: filter,
            valid: val,
            validFilter: valFilter,
            parameters: param,
            dataSourceID: dataSourceID
        };

        value.attrQueries.push(newQuery);

        value.enabled = true;

        this.handleValueChange(value);
    };

    changeRow = (obj, i) => {
        let value = _.clone(this.props.value);
        value.attrQueries = this.props.value.attrQueries.slice(0);

        value.attrQueries[i].dataDescriptor = obj;
        value.attrQueries[i].valid = this.validateAttrQuery(obj);

        value.enabled = true;

        this.handleValueChange(value);
    };

    changeFilters = (i: number) => {
        return (value: IAttrQueryFilterFieldValue) => {
            //LL: arr is filters array for "i"  DataQuery
            const valueCopy = _.clone(this.props.value);
            const attrQuery = valueCopy.attrQueries[i];

            attrQuery.filter = value.filters;
            attrQuery.validFilter = this.validateAttrQueryFilter(value.filters);
            attrQuery.globalFilterControl = value.globalFilterControl;

            valueCopy.enabled = true;

            this.handleValueChange(valueCopy);
        };
    };

    //LL: similar to Filters
    changeChartType = (i: number) => {
        //LL:  used when (this.useOwnChartType === true)
        let _self = this;
        return function (newChartType) {
            //LL: in changeChartType0:
            //LL: ChartType may be changed before obj (DataDef) is create.
            //   We can save it in State in this case (no obj is created).  And here take it from State

            let value = _.clone(_self.props.value);
            //value.parameters = _this.props.value.parameters.slice(0);
            value.attrQueries[i].parameters.chartType = newChartType;

            // validate here !!!  and change Axis list

            let obj = value.attrQueries[i].dataDescriptor;

            if (typeof _self.props.options.onChangeChartTypeAndAxisInAttrQuery === 'function') {
                _self.props.options.onChangeChartTypeAndAxisInAttrQuery(
                    obj,
                    newChartType,
                    _self._getChartAxisArrayField(),
                    _self._getExtendedAxisDisplay()
                );
            }

            let val = _self.validateAttrQuery(obj);
            value.attrQueries[i].valid = val;

            value.enabled = true;
            _self.handleValueChange(value);
        };
    };

    changeSecondaryValueAxis = (i: number) => {
        let _self = this;
        return function (newSecondaryValueAxis) {
            let newValue = newSecondaryValueAxis;
            if (newValue === _self.defaultValueAxis) {
                newValue = null;
            }

            let value = _.clone(_self.props.value);
            value.attrQueries[i].parameters.secondaryValueAxis = newValue; // newSecondaryValueAxis;

            // NO validate here !!!

            value.enabled = true;
            _self.handleValueChange(value);
        };
    };

    changeTitle = (i: number) => {
        let _self = this;
        return function (newTitle) {
            let value = _.clone(_self.props.value);

            //LL: was before OE updates:
            //value.parameters = _this.props.value.parameters.slice(0);
            //value.parameters[i].title = newTitle;

            //LL: by OE:
            //value.attrQueries[i].parameterstitle = newTitle;
            value.attrQueries[i].parameters.title = newTitle;

            // NO validate here !!!

            value.enabled = true;
            _self.handleValueChange(value);
        };
    };

    changeUsed = (i: number) => {
        return (newUsed) => {
            let value = _.clone(this.props.value);
            value.attrQueries[i].parameters.used = newUsed;

            // NO validate here !!!
            value.enabled = true;
            this.handleValueChange(value);
        };
    };

    changeDistinct = (i: number) => {
        return (newDistinct: boolean) => {
            let value = _.clone(this.props.value);
            value.attrQueries[i].parameters.distinct = newDistinct;

            // NO validate here !!!
            value.enabled = true;
            this.handleValueChange(value);
        };
    };

    changeQueryRootEntity = (i: number) => {
        return (newQueryRootEntity: string) => {
            let value = _.clone(this.props.value);
            value.attrQueries[i].parameters.queryRootEntity = newQueryRootEntity;

            // NO validate here !!!
            value.enabled = true;
            this.handleValueChange(value);
        };
    };

    changeLimit = (i: number) => {
        return (newLimit: number) => {
            let value = _.clone(this.props.value);
            value.attrQueries[i].parameters.limit = newLimit;

            // NO validate here !!!
            value.enabled = true;
            this.handleValueChange(value);
        };
    };

    changeDataSource = (i: number) => {
        let _self = this;

        return function (newDataSourceId) {
            let dsId = newDataSourceId;
            if (typeof dsId === 'string') {
                let K = parseFloat(newDataSourceId);

                if (!isNaN(K)) {
                    dsId = K;
                }
            }

            _self.props.glob.EntityModelsStore.storeDataSourceID(dsId);

            let value = _.clone(_self.props.value);
            value.attrQueries[i].dataSourceID = dsId;

            //LL: empty Data Source Descriptor:
            value.attrQueries[i].dataDescriptor = [];
            value.attrQueries[i].filter = [];
            value.attrQueries[i].valid = {};
            value.attrQueries[i].validFilter = {};

            _self.dataSourceChangedIndex = i;

            value.enabled = true;
            _self.handleValueChange(value);
        };
    };

    removeRow = (i: number) => {
        let value = _.clone(this.props.value);
        value.attrQueries.splice(i, 1);
        value.enabled = true;
        this.handleValueChange(value);
    };

    getTheme = () => {
        //LL: extend with current props.values.theme._custom
        //       Needed when, for example, AxisArray (AUX axis) is changed (added, removed)
        //       This new AxisArray value is not yet applied into props.options.theme
        //LL: deep $.extend is wrong here, at least for AxisArray - when Axis was removed, it will remain during deep $.extend
        //    So use shallow $.extend or _.extend
        let ownTheme = this.props.values.theme._custom;

        if (this.props.themeObj != null) {
            return _.extend({}, this.props.themeObj, ownTheme);
        }
        //LL: after:
        if (this.props.options != null && this.props.options.theme != null) {
            return _.extend({}, this.props.options.theme, ownTheme);
        }

        return ownTheme;
    };

    render() {
        //LL:  this.props.value.valids are set initially in componentWillMount
        let isMultiDataSourceMode = false;
        let dataSourceIds = null;
        let dataSourceNames = null;
        const dataSources = this.props.glob.EntityModelsStore.getDataSources();
        const tabID = this.props.options != null ? this.props.options.tabID : null;

        if (dataSources != null && dataSources.length > 1) {
            isMultiDataSourceMode = true;
        }
        if (isMultiDataSourceMode === true) {
            dataSourceIds = _.pluck(dataSources, 'dataSourceID');
            dataSourceNames = _.pluck(dataSources, 'name');
        }

        let chartTypeMain = this._getChartTypeMain();

        let chartTypesArray = [];

        if (typeof this.props.options.onGetFullChartTypesArray === 'function') {
            //LL:  if only one Block, full ChartTypes array (XY + Pie).  Otherwise depends on chartTypeMain (actually on 1st Block)
            if (this.props.value.attrQueries == null || this.props.value.attrQueries.length <= 1) {
                chartTypesArray = this.props.options.onGetFullChartTypesArray();
            } else {
                chartTypesArray = this.props.options.onGetFullChartTypesArray(chartTypeMain);
            }
        }

        let secondaryValueAxisArray;

        if (this.props.options.includeSeparateValueAxis === true) {
            let ChartAxisArrayField = this._getChartAxisArrayField();
            if (ChartAxisArrayField != null) {
                secondaryValueAxisArray = [];
                $.each(ChartAxisArrayField, (key: any, obj) => {
                    //LL: these keys are outdated functionality, not used anywhere. Was used when in Params, not in Themes
                    if (key !== 'isSet' && key !== 'removeAxis') {
                        secondaryValueAxisArray.push(key);
                    }
                });
            }
        }

        let formatsDateTime = [];
        if (this.props.options.formatsDateTime != null) {
            formatsDateTime = this.props.options.formatsDateTime.slice(0);
        }

        let formatsNumeric = [];
        if (this.props.options.formatsNumeric != null) {
            formatsNumeric = this.props.options.formatsNumeric.slice(0);
        }

        let showUsed = this.props.value.attrQueries.length > 1;
        let showUsedSingle = false;
        //LL: used=false for single can occur when there were 2, "used" set to false, and then the secong deleted
        if (!showUsed) {
            if (this.props.value.attrQueries.length === 1) {
                if (this.props.value.attrQueries[0].parameters.used === false) {
                    showUsed = true;
                    showUsedSingle = true;
                }
            }
        }

        const showTitle = this.props.value.attrQueries.length > 1; //LL: Leo wants so

        let xIDs = ['X1', 'X2', 'X3'];

        if (typeof this.props.options.onGetXids === 'function') {
            xIDs = this.props.options.onGetXids();
        }

        //LL: add Distinct and Data Limit into each Query
        let distinctInherited = this._getDistinct();
        let limitInherited = this._getLimit();

        const theme = this.getTheme();

        let rows = _.map(this.props.value.attrQueries, (obj, index) => {
            let chartType;

            if (this.useOwnChartType === true) {
                if (obj.parameters != null) {
                    chartType = obj.parameters.chartType;
                } else {
                    chartType = chartTypeMain;
                }
            }

            let secondaryValueAxis;
            if (this.includeSeparateValueAxis === true) {
                if (obj.parameters != null) {
                    secondaryValueAxis = obj.parameters.secondaryValueAxis;
                } else {
                    secondaryValueAxis = this.defaultValueAxis;
                }
            }

            let title;
            if (obj.parameters != null) {
                title = obj.parameters.title;
            }

            let used;

            if (obj.parameters != null) {
                used = obj.parameters.used;
            }

            //LL: add Distinct and Data Limit into each Query
            let distinct;

            if (obj.parameters != null) {
                distinct = obj.parameters.distinct;
            }

            if (distinct == null && distinctInherited != null) {
                distinct = distinctInherited;
            }

            let limit;
            if (obj.parameters != null) {
                limit = obj.parameters.limit;
            }
            if (limit == null && limitInherited != null) {
                limit = limitInherited;
            }

            let queryRootEntity;

            if (obj.parameters != null) {
                queryRootEntity = obj.parameters.queryRootEntity;
            }

            const dsChanged = this.dataSourceChangedIndex === index;
            const axisList = getVariatedAxisList(chartType);
            const showInTooltip_Defaults = this.props.options.ShowInTooltip_Defaults;

            //LL: nQueries for ReorderButton
            //See WI 101342. Visual reoredring does not work if key is not unique or is not changed during reordering.
            return (
                <AttrQueryMultiFieldRow
                    key={index + '-empty'}
                    i={index}
                    nQueries={this.props.value.attrQueries.length}
                    empty={true}
                    value={obj}
                    dataDescriptor={obj.dataDescriptor}
                    filter={obj.filter}
                    validFilterObj={obj.validFilter}
                    globalFilterControl={obj.globalFilterControl}
                    onChangeFilter={this.changeFilters(index)}
                    chartType={chartType}
                    onChangeChartType={this.changeChartType(index)}
                    secondaryValueAxis={secondaryValueAxis}
                    onChangeSecondaryValueAxis={this.changeSecondaryValueAxis(index)}
                    title={title}
                    onChangeTitle={this.changeTitle(index)}
                    used={used}
                    distinct={distinct}
                    limit={limit}
                    queryRootEntity={queryRootEntity}
                    onChangeUsed={this.changeUsed(index)}
                    showUsed={showUsed}
                    showUsedSingle={showUsedSingle}
                    showTitle={showTitle}
                    tabID={tabID}
                    onChangeDistinct={this.changeDistinct(index)}
                    onChangeQueryRootEntity={this.changeQueryRootEntity(index)}
                    onChangeLimit={this.changeLimit(index)}
                    dataSourceID={obj.dataSourceID}
                    dsChanged={dsChanged}
                    onChangeDataSource={this.changeDataSource(index)}
                    isMultiDataSourceMode={isMultiDataSourceMode}
                    dataSourceIds={dataSourceIds}
                    dataSourceNames={dataSourceNames}
                    values={this.props.values}
                    chartTypeMainFieldName={this.props.options.chartTypeMainFieldName}
                    onGetValidAxisMain2={this.props.options.onGetValidAxisMain2}
                    onGetAxisConversion={this.props.options.onGetAxisConversion}
                    onGetFullAxisArray={this.props.options.onGetFullAxisArray}
                    onGetExtendedAxisArray={this.props.options.onGetExtendedAxisArray}
                    axisList={axisList}
                    showInTooltip_Defaults={showInTooltip_Defaults}
                    chartAxisArrayFieldName_inTheme={this.props.options.ChartAxisArrayFieldName_inTheme}
                    onEvalAuxAxisNames={this.props.options.onEvalAuxAxisNames}
                    chartCustomStylesFieldName_inTheme={this.props.options.chartCustomStylesFieldName_inTheme}
                    get_colorMappingForNumericFromTheme_Func={
                        this.props.options.get_colorMappingForNumericFromTheme_Func
                    }
                    colorMappingForNumericFromTheme_both={this.props.options.colorMappingForNumericFromTheme_both}
                    extendedAxisDisplay_FieldName={this.props.options.extendedAxisDisplay_FieldName}
                    formatsDateTime={formatsDateTime}
                    formatsNumeric={formatsNumeric}
                    xIDs={xIDs}
                    validators_AttrQueryField={this.props.options.validators_AttrQueryField}
                    validators_AttrQueryFilterField={this.props.options.validators_AttrQueryFilterField}
                    argumentAxisProhibited={this.props.options.argumentAxisProhibited}
                    ownChartType={this.props.options.ownChartType}
                    chartTypesArray={chartTypesArray}
                    includeSeparateValueAxis={this.props.options.includeSeparateValueAxis}
                    secondaryValueAxisArray={secondaryValueAxisArray}
                    defaultValueAxis={this.defaultValueAxis}
                    theme={theme}
                    glob={this.props.glob}
                    onChange={this.changeRow}
                    onRemove={this.removeRow}
                />
            );
        });

        return (
            <div className={'attrquery-multi-field'}>
                <table className={'table' + (this.props.border === true ? ' table-bordered' : '')}>
                    <tbody
                        ref={(input) => {
                            this.references.tableBody = input;
                        }}
                    >
                        {rows}

                        <AttrQueryMultiFieldRow
                            fictiv={true}
                            theme={theme}
                            tabID={tabID}
                            glob={this.props.glob}
                            onAddRow={this.addRow}
                            onAddRow_CopyArgument={this.addRow_CopyArgument}
                            onAddRow_ClonedPrevious={this.addRow_ClonedPrevious}
                        />
                    </tbody>
                </table>
            </div>
        );
    }
}

export default class AttrQueryMultiField extends ParameterFieldBase<IAttrQueryMultiFieldOptions> {
    public static EditComponent = AttrQueryMultiFieldComponent;
    public static getDefaultValue() {
        return {
            enabled: false,
            attrQueries: []
        };
    }

    public static rowValidators: IValidator[];

    //LL: see ParameterFieldBase.ts - default
    public getEditViews(value): {
        [id: string]: {
            title: string;
            Component: any;
            componentOptions: any;
            componentProps: any;

            input: (value: any) => any;
            output: (input: any, value: any) => any;
        };
    } {
        let views = {};
        let multiUsingField = {
            title: 'Chart Enabler', //LL: Leo's title
            Component: AttrQueryMultiUsingField,
            componentOptions: {
                //parameters: value.parameters
            },
            componentProps: {
                glob: this.glob
            },
            input: function (value: IAttrQueryMulti) {
                let pars = _.map(value.attrQueries, (obj) => {
                    return _.clone(obj.parameters); // ok when 2 level deep
                });
                return pars;
            },
            output: function (input: IAttrQueryMulti, value) {
                //LL: a copy:  it is necessary, otherwise changes won't be applied
                let obj = $.extend(true, {}, input);

                for (let k = 0; k < value.length; k++) {
                    obj.attrQueries[k].parameters.used = value[k].used;
                }
                return obj;
            }
        };

        views['MultiUsingField'] = multiUsingField;

        return views;
    }

    constructor(glob: IGlob, title: string, validators?: any, defaultVal?: any, options?: IAttrQueryMultiFieldOptions) {
        if (defaultVal == null) {
            defaultVal = AttrQueryMultiField.getDefaultValue();
        }

        super(glob, title, [], validators, defaultVal, options);
    }
}

export function AttrQueryMultiUsingField(props: { value: any[]; onChange(obj): void }) {
    const handleValueChange = (index: number, checked: boolean) => {
        // props.value is "parameters"
        let obj = props.value.map((v) => ({ ...v })); // ok when 2 level deep

        if (obj[index] == null) {
            return;
        }
        obj[index].used = checked;

        if (typeof props.onChange === 'function') {
            props.onChange(obj);
        }
    };

    const parameters = Array.from(props.value);

    //LL: make readonly or prohibit carry out !!!
    let readOnly = parameters.length < 2;
    let enbNum = 0;

    parameters.forEach((par) => {
        if (par.used != false) {
            enbNum++;
        }
    });

    let elements = parameters.map((par, index) => {
        let title = par.title;

        if (title == null || title === '') {
            title = getDefaultTitleForAttrQuery(index);
        }

        const used = par.used ?? true;
        //LL: prohibit to disable all Queries:
        let disabled = readOnly;
        let lastUsed = enbNum <= 1 && used;

        if (!disabled) {
            disabled = lastUsed; // enbNum <= 1 && used;
        }

        //LL: 15.04.25 for proper style: bool field instead of input-ckeckbox
        let tooltip = '';
        if (lastUsed) {
            tooltip = 'disabled, cannot prohibit the last remaining one';
        }

        let style2 = { display: 'inline-block', marginLeft: 5, marginTop: 1 };

        return (
            <div key={index} style={{ display: 'inline-block', marginRight: 10, marginTop: 1 }}>
                <div style={style2}>
                    <BooleanField
                        title={null}
                        disabled={disabled}
                        readOnly={disabled}
                        value={used}
                        tooltip={tooltip}
                        onChange={(value) => {
                            handleValueChange(index, value);
                        }}
                    />
                </div>
                <label style={style2}>{title}</label>
            </div>
        );
    });

    return <div>{elements}</div>;
}

export function getDefaultTitleForAttrQuery(index: number) {
    return '__Q' + (index + 1).toString() + '__';
}
